import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1055"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M1.586 12.321c.091.016 1.427.24 2.99.24 1.019 0 2.134-.095 3.062-.405 3.753-1.253 6.211.066 6.312.123a.7.7 0 1 0 .689-1.219c-.091-.051-1.717-.942-4.314-.826.85-.627 1.525-1.477 1.854-2.497.833-2.583-.725-4.317-.926-4.594 1.6.334 2.946 2.433 2.884 4.095l.157.034c.296-2.932-1.638-5.569-4.307-6.121C7.366.61 4.509 2.175 3.795 4.679c-.788 2.762.759 4.29.964 4.569-1.505-.324-2.958-2.433-2.896-4.099l-.157-.034c-.285 2.791 1.463 5.293 3.933 6.005-1.826.154-3.791-.174-3.817-.178a.71.71 0 0 0-.808.572.7.7 0 0 0 .572.807zm6.659-7.357a1.255 1.255 0 1 1-.491 2.46 1.255 1.255 0 0 1 .491-2.46zm6.395 8.539c-.123-.069-3.069-1.692-7.444-.232-2.02.676-5.34.119-5.373.113a.708.708 0 0 0-.808.572.7.7 0 0 0 .571.808c.091.016 1.427.24 2.99.24 1.019 0 2.134-.095 3.062-.405 3.753-1.253 6.211.067 6.312.123a.698.698 0 0 0 .954-.265.699.699 0 0 0-.264-.954z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }